import React from "react";
import Tableau from "../../src/components/dv/Tableau";
import Datawrapper from "../../src/components/dv/Datawrapper";
import { graphql } from "gatsby";
import { MDXRenderer } from "gatsby-plugin-mdx";
import { Box, Button, Typography, withStyles } from "@material-ui/core";
import Layout from "gatsby-theme-hypersite/src/layout";
import { formatDate } from "../utils";
import { Content } from "../components";

const ReportPage = ({ classes, data, ...props }) => {
	const report = { ...data.mdx, ...data.mdx.frontmatter };

	return (
		<Layout {...props}>
			<Box className={classes.root}> 
				<Content className={classes.content}>
					<Box className={classes.meta}>
						{report.date ? (
							<Box>
								<Typography variant="h6">Published</Typography>
								<Typography paragraph>{formatDate(report.date)}</Typography>
							</Box>
						) : null}

						{report.authors ? (
							<Box>
								<Typography variant="h6">Authors</Typography>
								<Typography paragraph>{report.authors.join(", ")}</Typography>
							</Box>
						) : null}

						{report.url ? (
							<Box className={classes.buttonWrapper}>
								<Button
									role="presentation"
									variant="contained"
									target="_blank"
									href={report.url}
									className={classes.button}
								>
									Open report
								</Button>
							</Box>
						) : null}
					</Box>

					<MDXRenderer {...report} {...props}>
						{report.body}
					</MDXRenderer>
				</Content>
			</Box>
		</Layout>
	);
};

export default withStyles(theme => ({
	root: {
		paddingTop: 0,
		overflow: "hidden",
	},
	content: {
		"& > *:first-child": {
			marginTop: 0
		},
		"& > iframe": {
			width: "100%",
			height: "auto",
			aspectRatio: "16 / 9",
			margin: theme.spacing(4, "auto"),
			"@media (min-width: 960px)": {
				width: "900px",
				maxWidth: "calc(100vw - 3rem)",
				transform: `translateX(calc((900px - 50rem + 6rem) / -2))`,
			}
		},
		"& .data-wrapper-container, & .tableau-container": {
			marginTop: theme.spacing(4),
			marginBottom: theme.spacing(4),
			padding: theme.spacing(8, 4),
			backgroundColor: theme.palette.background.alt,
			display: "flex",
			alignItems: "center",
			overflow: "hidden",
			"@media (min-width: 720px)": {
				width: "100vw",
				transform: `translateX(calc((100vw - 50rem + 3rem) / -2))`,
			},
			"@media (min-width: 960px)": {
				width: "100vw",
				transform: `translateX(calc((100vw - 50rem + 6rem) / -2))`,
			},
			"& > *": {
				margin: "auto"
			},
			"& iframe": {
				border: "none",
				width: "100%",
				// padding: theme.spacing(1),
				// borderWidth: "2px !important",
				// borderStyle: "solid !important",
				// borderColor: `${theme.palette.blue.med} !important`,
				// borderRadius: `${theme.shape.borderRadius}px !important`,
			}
		},
		"& .data-wrapper-container": {
			"& iframe": {
				maxWidth: "900px",
				// padding: theme.spacing(4),
			}
		},
		"& .tableau-container": {
			"& .tableauPlaceholder": {
				"& iframe": {
					width: "100%",
					maxWidth: "100%",
					backgroundColor: theme.palette.background.paperSecondary,
				}
			}
		},
	},
	meta: {
		marginBottom: theme.spacing(4),
		paddingBottom: theme.spacing(2),
		borderBottom: `2px solid ${theme.palette.blue.med}`
	},
	buttonWrapper: {
		padding: theme.spacing(4, 0),
		"& .MuiButton-root": {}
	},
	button: {
		"& .MuiButton-label::after": {
			content: `""`,
			width: theme.spacing(2),
			height: theme.spacing(2),
			display: "inline-block",
			marginTop: 0,
			marginLeft: theme.spacing(1),
			backgroundPosition: "center",
			backgroundRepeat: "no-repeat",
			backgroundSize: "cover",
			backgroundImage: "url(/images/icon-launch-light.svg)",
			borderWidth: 0,
			transform: "none"
		}
	}
}))(ReportPage);

export const reportQuery = graphql`
	query ($id: String) {
		mdx(id: { eq: $id }) {
			id
			slug
			body
			frontmatter {
				authors
				blurb
				date
				name
				title
				url
			}
		}
	}
`;
